import { Box, Button } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useGetBedRequestsQuery } from "../services/bedRequestService";
import BedRequestFormModal from "../components/BedRequestFormModal";
import { getBedRequestsColumns } from "../data/bedRequests";

const BedRequests = () => {
  const navigate = useNavigate();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [bedRequest, setBedRequest] = useState(null);

  const {
    data: bedRequests,
    error,
    isFetching,
    refetch,
  } = useGetBedRequestsQuery({ page: 1, pageSize: 10 });

  const handleAddSuccess = () => {
    refetch();
    setIsModalOpen(false);
  };

  if (isFetching) return <div>Loading...</div>;

  if (error) return <div>Error fetching users</div>;

  const handleView = (BedRequest: any) => {
    navigate(`/bed-requests/${BedRequest._id}`);
  };

  const handleEdit = (bedRequest: any) => {
    setBedRequest(bedRequest);
    setIsModalOpen(true);
  };

  const handleDelete = (bedRequest: any) => {};

  const columns = getBedRequestsColumns(handleView, handleEdit, handleDelete);

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
      <Box sx={{ display: "flex", justifyContent: "flex-end", mb: 2 }}>
        <Button
          variant="contained"
          color="primary"
          onClick={() => {
            // Handle add user logic here
            setBedRequest(null);
            setTimeout(() => {
              setIsModalOpen(true);
            }, 100);
          }}
        >
          Add Bed Request
        </Button>
      </Box>
      <DataGrid
        rows={bedRequests?.data?.requests || []}
        columns={columns}
        getRowId={(row) =>
          row._id || Math.random().toString(36).substring(2, 9)
        }
        initialState={{
          pagination: {
            paginationModel: {
              pageSize: 10,
            },
          },
        }}
        pageSizeOptions={[10]}
        disableRowSelectionOnClick
        sx={{
          "& .MuiDataGrid-cell": {
            padding: "8px 16px",
          },
          "& .MuiDataGrid-columnHeaders": {
            backgroundColor: "#f5f5f5",
          },
        }}
      />

      {/* Add/Edit Appointment Modal */}
      <BedRequestFormModal
        open={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        onSuccess={handleAddSuccess}
        bedRequest={bedRequest}
      />
    </Box>
  );
};

export default BedRequests;
